import React from 'react';
import { ArrowRight } from '@phosphor-icons/react';

const FieldPreview = ({ label, value, fromDupe }) => {
  const valueClass = fromDupe
    ? 'text-emerald-700 bg-emerald-50 px-1 rounded'
    : value
    ? 'text-slate-800'
    : 'text-slate-300 italic';
  return (
    <div className="flex flex-col">
      <span className="text-xs text-slate-500">{label}</span>
      <span className={`text-sm font-medium ${valueClass}`}>
        {value || 'empty'}
        {fromDupe && <span className="text-xs ml-1 text-emerald-500">(filled)</span>}
      </span>
    </div>
  );
};

/**
 * Read-only summary of what the record will look like AFTER merge —
 * fields filled from duplicates are highlighted with an emerald background.
 */
const MergePreview = ({ merged, displayFields }) => (
  <div className="border rounded-lg overflow-hidden">
    <div className="bg-indigo-50 px-4 py-2 border-b flex items-center gap-2">
      <ArrowRight size={16} className="text-indigo-600" />
      <span className="text-sm font-semibold text-indigo-800">Merged Result Preview</span>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-2 p-4">
      {displayFields.map(({ key, label }) => {
        const val = merged.preview[key];
        const source = merged.filledFrom[key];
        const fromDupe = source && source !== 'primary' && source !== null;
        return <FieldPreview key={key} label={label} value={val} fromDupe={fromDupe} />;
      })}
    </div>
  </div>
);

export default MergePreview;
